import React from 'react';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class Apertura2008 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 524; i <= 542; i++) {
        	id_list.push(i);
        }
    this.state = {
	showCards: true,
      path: this.props.path,
	kit_path: '/images/kits/todas/',
      kits: [],
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,
      table1:[
	 {'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':19, 'pg':6,'pe':3,'pp':10,'gf':27,'gc':33,'dif':-6, 'pts':21},
              {'color':'#135683','shortname':'catolica', 'rivalName':'U. Católica', 'pj':19, 'pg':11,'pe':3,'pp':5,'gf':37,'gc':19,'dif':18, 'pts':36},
	{'color':0,'shortname':'rangers', 'rivalName':'Rangers', 'pj':19, 'pg':6,'pe':6,'pp':7,'gf':23,'gc':25,'dif':-2, 'pts':24},
              {'color':'#135683','shortname':'nublense', 'rivalName':'Ñublense', 'pj':19, 'pg':12,'pe':5,'pp':2,'gf':28,'gc':14,'dif':14, 'pts':41},
	{'color':0,'shortname':'concepcion', 'rivalName':'Dep. Concepción', 'pj':19, 'pg':7,'pe':3,'pp':9,'gf':33,'gc':37,'dif':-4, 'pts':18}
		],

	table2:[{'color':'#295e1e','shortname':'cobreloa', 'rivalName':'Cobreloa', 'pj':19, 'pg':6,'pe':5,'pp':8,'gf':25,'gc':29,'dif':-4, 'pts':23},
              {'color':'#295e1e','shortname':'audax', 'rivalName':'Audax Italiano', 'pj':19, 'pg':11,'pe':1,'pp':7,'gf':35,'gc':25,'dif':10, 'pts':34},
	     {'color':0,'shortname':'morning', 'rivalName':'S. Morning', 'pj':19, 'pg':9,'pe':3,'pp':7,'gf':35,'gc':42,'dif':-7, 'pts':30},
              {'color':0,'shortname':'osorno', 'rivalName':'Provincial Osorno', 'pj':19, 'pg':5,'pe':1,'pp':13,'gf':19,'gc':38,'dif':-19, 'pts':16},
	      {'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':19, 'pg':6,'pe':3,'pp':10,'gf':27,'gc':33,'dif':-6, 'pts':21},
              {'color':'#135683','shortname':'catolica', 'rivalName':'U. Católica', 'pj':19, 'pg':11,'pe':3,'pp':5,'gf':37,'gc':19,'dif':18, 'pts':36},
              {'color':'#295e1e','shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':19, 'pg':7,'pe':6,'pp':6,'gf':35,'gc':29,'dif':6, 'pts':27},
              {'color':0,'shortname':'cobresal', 'rivalName':'Cobresal', 'pj':19, 'pg':9,'pe':4,'pp':6,'gf':35,'gc':26,'dif':9, 'pts':31},
              {'color':0,'shortname':'huachipato', 'rivalName':'Huachipato', 'pj':19, 'pg':7,'pe':6,'pp':6,'gf':29,'gc':29,'dif':0, 'pts':27},
              {'color':'#295e1e','shortname':'udechile', 'rivalName':'U. de Chile', 'pj':19, 'pg':9,'pe':3,'pp':7,'gf':28,'gc':23,'dif':5, 'pts':30},
              {'color':0,'shortname':'rangers', 'rivalName':'Rangers', 'pj':19, 'pg':6,'pe':6,'pp':7,'gf':23,'gc':25,'dif':-2, 'pts':24},
              {'color':'#135683','shortname':'nublense', 'rivalName':'Ñublense', 'pj':19, 'pg':12,'pe':5,'pp':2,'gf':28,'gc':14,'dif':14, 'pts':41},
              {'color':0,'shortname':'union', 'rivalName':'U. Española', 'pj':19, 'pg':7,'pe':3,'pp':9,'gf':20,'gc':27,'dif':-7, 'pts':24},
              {'color':'#295e1e','shortname':'ohiggins', 'rivalName':'O\'Higgins', 'pj':19, 'pg':10,'pe':6,'pp':3,'gf':30,'gc':17,'dif':13, 'pts':36},
	      {'color':0,'shortname':'laserena', 'rivalName':'La Serena', 'pj':19, 'pg':7,'pe':5,'pp':7,'gf':29,'gc':29,'dif':0, 'pts':26},
	      {'color':'#295e1e','shortname':'everton', 'rivalName':'Everton', 'pj':19, 'pg':10,'pe':2,'pp':7,'gf':34,'gc':30,'dif':4, 'pts':32},
              {'color':0,'shortname':'palestino', 'rivalName':'Palestino', 'pj':19, 'pg':7,'pe':3,'pp':9,'gf':28,'gc':27,'dif':1, 'pts':24},
              {'color':0,'shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':19, 'pg':4,'pe':5,'pp':10,'gf':16,'gc':29,'dif':-13, 'pts':17},
              {'color':0,'shortname':'concepcion', 'rivalName':'Dep. Concepción', 'pj':19, 'pg':7,'pe':3,'pp':9,'gf':33,'gc':37,'dif':-4, 'pts':18}]

    };
  }

  componentDidMount() {
		this.getKits();
		let _newtable = this.sortTable(this.state.table1);
                this.setState({table1:_newtable});
		let newtable = this.sortTable(this.state.table2);
  		this.setState({table2:newtable});

	}

getKits(){

        fetch("https://www.registrosudec.com:5000/kits", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", soc$
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}


  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={3} xl={3} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color} style={{width:'20px'}}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
			aux = table[j+1];
			table[j+1] = table[j];
                        table[j] = aux;
		} 
	     }		
	}
return table;

}


render(){


  let subT = this.subText('#295e1e', 'Clasificado a Play-Off');
  let subC = this.subText('#135683', 'Clasificado a Play-Off y a Sudamericana 2008');
  return(

	<div style={{textAlign: 'center' }}>
	    <div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Apertura 2008</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>

      <div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Grupo 4 </div>
	<div style={{ height: '10px' }}></div>
	{<Tabla teams={this.state.table1} />}
        <div style={{ height: '10px' }}></div>
	<div> * Dep. Concepción tiene 6 puntos menos por utilizar jugador no habilitado en fecha 2 </div> 
        <div style={{ height: '10px' }}></div>
         {subT}


	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Tabla General</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table2} />}
        <div style={{ height: '10px' }}></div>
	<div> * Dep. Concepción tiene 6 puntos menos por utilizar jugador no habilitado en fecha 2 </div> 
        <div style={{ height: '10px' }}></div>
         {subC}
         {subT}

	
	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Apertura 2008</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Apertura 2008</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Apertura 2008" />
     </div>


  )
}

}
export default Apertura2008;
